import isEqual from 'lodash/isEqual';
import {ComparisonCondition} from '@/model/types/migrations/condition';
import {DocumentValue} from '../../types';

const isScalar = (value: DocumentValue): value is string => {
  return typeof value === 'string';
};

export const compareValues = (
  valueA: DocumentValue,
  valueB: DocumentValue,
  operator: ComparisonCondition['operator'],
) => {
  switch (operator) {
    case '=':
      return isEqual(valueA, valueB);
    case '!=':
      return !isEqual(valueA, valueB);
    default: {
      if (!isScalar(valueA) || !isScalar(valueB)) {
        throw new Error(`Invalid comparison between ${typeof valueA} and ${typeof valueB}`);
      }

      switch (operator) {
        case '>':
          return !!valueA && !!valueB && parseFloat(valueA) > parseFloat(valueB);
        case '>=':
          return !!valueA && !!valueB && parseFloat(valueA) >= parseFloat(valueB);
        case '<':
          return !!valueA && !!valueB && parseFloat(valueA) < parseFloat(valueB);
        case '<=':
          return !!valueA && !!valueB && parseFloat(valueA) <= parseFloat(valueB);
      }
    }
  }
};
